// import { useLocation, useNavigate } from "react-router-dom";
// import "../styles/floatingSoftwareDemo.css";

// const FloatingSoftwareDemo = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Hide from admin pages
//   if (location.pathname.startsWith("/admin")) {
//     return null;
//   }

//   return (
//     <button
//       type="button"
//       className="floating-software-demo"
//       onClick={() => navigate("/software")}
//       aria-label="Book software demo"
//       title="Book Software Demo"
//     >
//       <img
//         src="/images/book-software-demo-lyrazone-lyra-zone.png"
//         alt="Book Software Demo"
//       />
//     </button>
//   );
// };

// export default FloatingSoftwareDemo;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/floatingSoftwareDemo.css";

const FloatingSoftwareDemo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);
  }, [location.pathname]);

  const hiddenPaths = ["/admin", "/software"];

  const shouldHideByPath = hiddenPaths.some((path) =>
    location.pathname.startsWith(path),
  );

  if (!isVisible || shouldHideByPath) {
    return null;
  }

  return (
    <div className="floating-software-demo-wrap">
      <button
        type="button"
        className="floating-software-demo-close"
        onClick={() => setIsVisible(false)}
        aria-label="Close book software demo floating icon"
        title="Close"
      >
        ×
      </button>

      <button
        type="button"
        className="floating-software-demo"
        onClick={() => navigate("/software")}
        aria-label="Book software demo"
        title="Book Software Demo"
      >
        <img
          src="/images/book-software-demo-lyrazone-lyra-zone.png"
          alt="Book Software Demo"
        />
      </button>
    </div>
  );
};

export default FloatingSoftwareDemo;
